import React, { useState } from 'react';
import styles from '../../Accounting.module.css';

const faqData = [
  {
    q: 'What gets recorded automatically?',
    a: 'Your Fyntiq invoices and payments — amount, client, date, processing fees, and receipts — are logged and reconciled as they happen, with no manual entry.',
  },
  {
    q: 'Does this replace my accountant?',
    a: "No. Fyntiq keeps your income records organized and export-ready, but it isn't a full accounting suite or tax advice. It's designed to make your accountant's job — and yours — much easier.",
  },
  {
    q: 'Can I export for taxes?',
    a: 'Yes. Export income summaries, full transaction logs, and fees as CSV or PDF — for any period — to file yourself or send to your accountant.',
  },
  {
    q: 'Does it track expenses too?',
    a: "Yes. Your Fyntiq income records automatically, and you can add other expenses by uploading a receipt or connecting your bank account to import and categorize spending. Fyntiq's AI helps organize all of it so you're ready for tax season.",
  },
  {
    q: 'Is my financial data secure?',
    a: 'Yes. Your records are encrypted and protected, and only you and the people you choose to share exports with can see them.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Accounting questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div
                className={styles.faqQ}
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}
              >
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
